import { Ajax } from '../classes/ajax';
import parseQueryString from '../utils/parse-query-string';

export function LoadPackages(product_id) {
    return async function(dispatch) {
        dispatch({
            type: 'PACKAGES/LOAD',
        });

        let hotel_filter_query = '';
        let query = parseQueryString(document.location.search);
        if (query.hotelId != null) {
            hotel_filter_query = '?hotel_filter=' + query.hotelId;
        }

        return new Ajax(
            'GET',
            'tickets/' + product_id + hotel_filter_query,
        ).then((result) => {
            result.data.items.map((val) => {
                val.month = new Date(val.month * 1000);

                val.data.map((item) => {
                    item.date = new Date(item.date * 1000);
                    item.hotel.date = new Date(item.hotel.date * 1000);
                    item.ticket.date = new Date(item.ticket.date * 1000);

                    item.tickets.forEach((ticket) => {
                        ticket.date = new Date(ticket.date * 1000);
                    });
                });
            });

            dispatch({
                type: 'PACKAGES/LOAD_FINISHED',
                payload: {
                    packages: result.data.items,
                    show_sold_out: result.data.show_sold_out,
                },
            });
        });
    };
}

export function ReloadPackages() {
    return function(dispatch) {
        dispatch({
            type: 'APP/CLEAR',
        });

        dispatch(LoadPackages(NOJESRESOR_PRODUCT.id));
    };
}

export function SelectPackage(pkg) {
    return function(dispatch) {
        dispatch({
            type: 'PACKAGES/SELECT',
            payload: {
                package: pkg,
            },
        });
    };
}

export function DeselectPackage() {
    return function(dispatch) {
        dispatch({
            type: 'APP/CLEAR',
        });
    };
}

export function DeselectConfirmedPackage() {
    return function(dispatch) {
        dispatch({
            type: 'APP/CLEAR',
        });
    };
}
